import React, { useCallback, useState, useEffect } from 'react';
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';
import { UploadModal } from './UploadModal';
import style from './ScreenList.module.css';
import classnames from 'classnames';

interface ListItemProps {
  value: Cockpit.Screen;
  onChange(option: string, id: string, value: any): Promise<any>;
}

const ref = React.createRef<HTMLInputElement>();
export function Title({ children, onChange, className }: any) {
  const [text, setText] = useState(children);
  const [editing, setEdit] = useState(false);

  const _onChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => setText(e.target.value), [text]);
  const onSave = useCallback(() => {
    onChange(text);
    setEdit(false);
  }, [text]);

  const onCancel = () => {
    setText(children);
    setEdit(false);
  };

  useEffect(() => {
    const onclick = (e: Event) => {
      if (ref.current && ref.current !== e.target) {
        onSave();
      }
    };
    if (editing) {
      window.addEventListener('click', onclick);
    }
    return () => {
      window.removeEventListener('click', onclick);
    };
  }, [editing, ref, text]);

  if (editing) {
    return (
      <div className={className}>
        <a className={classnames('iconfont icon-icon_edit')}></a>
        <input
          ref={ref}
          onChange={_onChange}
          value={text}
          onKeyDown={(e) => {
            e.keyCode === 13 && onSave();
            e.keyCode === 27 && onCancel();
          }}
          onBlur={() => onSave()}
        />
      </div>
    );
  }
  return (
    <div
      className={className}
      onClick={() => {
        setEdit(true);
        setTimeout(() => {
          ref.current?.select();
        }, 0);
      }}
      style={{ cursor: 'pointer' }}
    >
      <a className={classnames('iconfont icon-icon_edit')}></a>
      {text}
    </div>
  );
}

const DragHandle = SortableHandle(() => <a className={classnames(style.item__move, 'iconfont icon-btn_move')}></a>);
export const ScreenItem = SortableElement(function ListItem(props: ListItemProps) {
  const { value } = props;
  const onTitleChange = (text: string) => props.onChange('name', value.id, text);

  const onStatusSwitch = () => props.onChange('publish', value.id, !value.show);

  const onImageChange = (urls: string[], files: File[]) => props.onChange('thumb', value.id, files[0]);
  return (
    <div className={style.item}>
      <div className={style.item__tool}>
        <DragHandle />
      </div>
      <UploadModal title="上传封面图" files={[value.image]} onSave={onImageChange}>
        <img src={value.image} className={style.item__img} />
      </UploadModal>
      <div className={style.item__bar}>
        <div className={style.item__title}>
          <Title className={style.item__titlev} onChange={onTitleChange}>
            {value.title}
          </Title>
          <a
            className={classnames(style.item__visiable, 'iconfont', {
              'icon-icon_right_open': value.show,
              'icon-icon_right_hide': !value.show
            })}
            onClick={onStatusSwitch}
          ></a>
        </div>
        <div className={style.item__desc}>发布时间：{value.publishTime}</div>
      </div>
    </div>
  );
});
